import React from 'react'
import {
  FormDashboardLabel as Label,
  User,
} from '../../../components'

import { PartnerPopup } from './partner-popup'
import { Plus } from 'react-feather'

const SidebarPartner = () => {
  const [popedUp, setPopedUp] = React.useState(false)

  return (
    <div>
      <div>
        {/* Desktop */}
        <div className="hidden lg:block">
          <Label>Partners</Label>
        </div>

        {/* Mobile */}
        <div className="flex lg:hidden items-center justify-between mb-3">
          <p className="text-sm font-bold">Partners</p>
          <div className="text-primary text-sm flex items-center" onClick={() => setPopedUp(true)}>
            <Plus width={16} height={16} className="mr-1"/>
            <p>Add</p>
          </div>
        </div>

        <div className="flex items-center justify-between mb-2">
          <User small name="AIPJ2"/>
          {/* <p className="text-xs text-gray-999 underline cursor-pointer">Delete</p> */}
        </div>
        <div className="flex items-center justify-between mb-3">
          <User small name="Maarif Institute"/>
          {/* <p className="text-xs text-gray-999 underline cursor-pointer">Delete</p> */}
        </div>
        <p className="hidden lg:block link" onClick={() => setPopedUp(true)}>+ Add new partner</p>
      </div>
      {
        popedUp &&
        <PartnerPopup onClose={setPopedUp} />
      }
    </div>
  )
}

export { SidebarPartner }